<template>
  <div class="topLevel">
    <div class="button" :class="{grey: !(match =='start' || match =='plus') }">
      <div class="staticBackground"></div>
      <div class="background" v-if="match=='start' || match=='plus'"></div>
      <div class="input" :class="{finished: match=='end' || match=='prestart' }" @click="jump">
        {{title}}
        <!-- <div class="tips fs18" :class="{block: !user}" >国赛将于6月15日18:00结束</div> -->
        <!-- <div class="tips fs18" v-if="state == 'final-end'">金牌附加赛 1月20日上午10:00-10:30</div> -->
      </div>
    </div>
    <!-- <div class="tip fs18" :class="{display: user}">登陆有问题请联系客服QQ：1011635189</div> -->
    <!-- <div class="tip fs18" :class="{display: cq}"><router-link :to="{name: 'CQ'}">CodeQuest</router-link> </div> -->
  </div>
</template>

<script>
export default {
  name: 'TitleButton',
  props: ['state'],
  computed: {
    title () {
      if(this.state == 'primary-prestart')
      {
        return 'AI挑战即将开始'
      }
      else if(this.state == 'primary-start')
      {
        return 'AI挑战开始'
      }
      else if(this.state == 'primary-end' || this.state=='final-prestart')
      {
        return '初赛结束'
      }
      else if(this.state == 'final-start')
      {
        return '进入决赛'
      }
      else if(this.state == 'final-plus-prestart')
      {
        return '附加赛即将开始'
      }
      else if (this.state == 'aoc-start') {
        return '进入亚洲赛'
      } else if (this.state == 'cq-start') {
        return 'CodeQuest'
      }
      else if (this.state =='final-plus')
      {
        return '进入附加赛'
      }
      else if (this.state == 'final-end') {
        return '决赛结束'
      }
      else if(this.state == 'reward-start')
      {
        return '我的成绩'
      }
    },
    match () {
      const m = this.state.split('-')[1]
      if(m == 'start' && new Date() < new Date('2023-06-02 08:30:00')) {
        return 'prestart'
      }
      return m
    },
    user() {
      return this.$store.state.auth.user
    },
    gameState() {
      return this.$store.state.auth.game_state
    },
    cq () {
      if(this.user) {
        let state = this.gameState['2026-cq']
        return state && state.state == 1
      }
    },
  },
  methods: {
    jump() {
      if(this.state == 'primary-prestart') {
        return;
      }
      if(this.user){
        if(this.state == 'primary-start') {
          if(this.user.enrolled) {
            this.$router.push({name: 'Preliminary'})
          }
          else{
            this.$router.push({name: 'enroll'})
          }
        }
        else if(this.state == 'final-start')
        {
          if (this.user.group === 5) {
            const url = '/play/junior?course=65f32b6c87c07dbeb5ba1936&course-instance=6897fd23097f759d1e53b488'
            window.open(this.$store.state.gamelink+this.$store.state.auth.token.token + `&redirect=${encodeURIComponent(url)}`)
          } else {
            this.$http.get('/api/ladder/url').then(res => {
              window.open(this.$store.state.gamelink+this.$store.state.auth.token.token + `&redirect=${encodeURIComponent(res.data)}`, '_blank')
            })
          }
        }
        else if (this.state == 'aoc-start') {
          this.$router.push({name: 'AOC'})
        } else if (this.state == 'cq-start') {
          this.$router.push({name: 'CQ'})
        }
        else if (this.state == 'final-plus')
        {
          this.$router.push({name: 'Repecharge'})
        }
        else if (this.state == 'reward-start')
        {
          this.$router.push({name:'reward'})
        }
      }
      else
      {
        this.$router.push({name:'account', params:{type:'login'}})
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button{
  color: white;
  margin-top: 2.2vw;
  width: 12.4vw;
  height: 3.5vw;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  background: transparent;
  position: relative;
}
.button.grey{
  overflow: visible;
}
.button>div{
  width: 12.4vw;
  height: 3.5vw;
  position: absolute;
  top: 0;
  left: 0;
}
.button .staticBackground{
  z-index: 1;
  border-radius: 4px;
  background: var(--yellow);
}
.button.grey .staticBackground{
  background: rgba(200,200,200, 0.7);
}
.button .background{
  z-index: 2;
  background: linear-gradient(to right,var(--yellow),var(--orange));
  transition: left 1s linear;
}
.button:hover > .background {
  left: 12.4vw;
  transition: left 1s ease;
}
.button .input{
  display:flex;
  justify-content: center;
  align-items: center;
  font-family: "Andale Mono", AndaleMono, monospace;
  font-size: 1.4vw;
  letter-spacing: 0.2vw;
  z-index: 5;
  position: relative;
}

.tip{
  display: none;
  position: absolute;
  width: 24em;
  text-align:center;
  height: 1.5em;
  color: var(--yellow);
  bottom: -2.2em;
}

.tip a {
  color: var(--yellow);
}
.tips{
  display: none;
  position: absolute;
  width: 24em;
  text-align:center;
  height: 1.5em;
  color: var(--yellow);
  border-radius: 5px;
  top: -1.4em;
  /* background: white; */
}
.display{
  display: block !important;
}
.input.finished:hover > .tips{
  display: block;
}
.block{
  display: none !important;
}

.topLevel{
  font-family: "Andale Mono", AndaleMono, monospace;
  font-size: 1.4vw;
  position: relative;
  display: flex;
  justify-content: center;
  letter-spacing: 0.2vw;
}
</style>
